import { combineReducers } from 'redux';
import { loginReducer } from '../reducer/loginReducer';
import { callPermissionDetail } from '../reducer/callPermissionDetail';
import { conferenceDetails } from '../reducer/conferenceDetails';
import { updatedCallList } from '../reducer/currentCallStatus';
import { userAgentDetail } from '../reducer/userAgentDetail';
import { directNumberDetail } from '../reducer/directNumber';
import { contactReducer } from '../reducer/contactReducer';
import { chatReducer } from '../reducer/chatReducer';
import { recentchatReducer } from '../reducer/recentchatReducer';
import { chatWindowReducer } from '../reducer/chatwindowReducer';
import { contactWindowReducer } from '../reducer/contactwindowReducer';
import { chatRightSidePanelReducer } from '../reducer/chatRightSideReducer';
import { ASR_Language } from '../reducer/ASR_Language';
import { incomingCallWindow } from '../reducer/incomingCallWindow';
import { toastReducer } from '../reducer/toastReducer';
import { showError } from '../reducer/showError';
import { closeCaption } from '../reducer/closeCaption';
import { profileReducer } from '../reducer/profileReducer';
import DropBoxStorageReducerState from '../reducer/dropboxReducer';
import { chatSocketReducerState } from '../reducer/chatSocketReducer';
import { chatSocketRecentReducerState } from '../reducer/chatSocketRecentReducer';
import { meetingReducer } from '../reducer/meetingReducer';
import { callReducer } from '../reducer/callReducer';
import { typingReducerState } from '../reducer/typingReducer';
import { deviceListReducer } from '../reducer/activeDeviceReducer';
import { serverDisconnectReducer } from '../reducer/serverDisconnect';
import { startingScreenReducer } from '../reducer/startingScreenReducer';
import { internetReducer } from '../reducer/internetReducer';
import {bellNotification} from '../reducer/bellNotificationReducer';
import { recentChatTabReducer } from '../reducer/tabModelReducer';

const rootReducer = combineReducers({
  loginReducer,
  updatedCallList,
  callPermissionDetail,
  conferenceDetails,
  userAgentDetail,
  directNumberDetail,
  contactReducer,
  chatReducer,
  recentchatReducer,
  chatWindowReducer,
  contactWindowReducer,
  internetReducer,
  chatRightSidePanelReducer,
  ASR_Language,
  incomingCallWindow,
  toastReducer,
  showError,
  closeCaption,
  profileReducer,
  DropBoxStorageReducerState,
  chatSocketReducerState,
  chatSocketRecentReducerState,
  meetingReducer,
  callReducer,
  typingReducerState,
  deviceListReducer,
  serverDisconnectReducer,
  startingScreenReducer,
  bellNotification,
  recentChatTabReducer
});
export default rootReducer;
